import React from 'react';
import PropTypes from 'prop-types';
import Modal from './ModalComponent.component';
import PrimaryButton from '../Buttons/PrimaryButton/PrimaryButton.component';
import { useNavigate } from 'react-router-dom';

const ResultModal = ({ isOpen, onClose, result, linkTo, span = 'Go Home' }) => {
  if (!isOpen) return null;
  const navigate = useNavigate();
  const navigateTo = () => {
    onClose();
    navigate(linkTo);
  };

  return (
    <Modal onClose={onClose}>
      <p>{result}</p>
      <PrimaryButton functionName={navigateTo} span={span} />
    </Modal>
  );
};
ResultModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  result: PropTypes.string,
  linkTo: PropTypes.string,
  span: PropTypes.string,
};
export default ResultModal;
